// removed by extract-text-webpack-plugin
module.exports = {"InputElement":"Input__-loca-__3TB0k","TextArea":"Input__-loca-__250iG","ValidationError":"Input__-loca-__ukId8","InputWrapper":"Input__-loca-__1Z5oR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 122
// module chunks = 0